import type { TeamMember } from '../data/team';

interface TeamCardProps {
  member: TeamMember;
}

export default function TeamCard({ member }: TeamCardProps) {
  return (
    <div className="team-card card">
      <div
        className="team-card__avatar"
        style={{ background: member.gradient }}
        aria-hidden="true"
      >
        <span className="team-card__initials">{member.initials}</span>
      </div>
      <h3 className="team-card__name body-bold">{member.name}</h3>
      <p className="team-card__role caption">{member.role}</p>
      <p className="team-card__bio caption">{member.bio}</p>
    </div>
  );
}
